"use client";

import type React from "react";
import styles from "./LandingPageLayout.module.scss";
import Header from "../../../layouts/public-layout-form/components/Header";
import { forwardRef } from "react";

interface LandingPageLayoutProps {
	title?: string;
	subtitle?: string;
	children: React.ReactNode;
	showMenu?: boolean;
	className?: string;
	menuComponent?: React.ReactNode;
    containerClass?: string;
}

export const LandingPageLayout = forwardRef<HTMLDivElement, LandingPageLayoutProps>(
  ({ title = "", subtitle = "", children, showMenu = true, className = "", containerClass= "", menuComponent }, ref) => {
    return (
		<div ref={ref} className={`${styles.layout} ${className}`}>
			<div className={`${styles.container} ${containerClass}`}>
				<div className={styles.menuContainer}>{showMenu && menuComponent}</div>

				{/* Main Content Area */}
				<div className={styles.content}>
					{/* Header */}
					{(subtitle || title) && (
						<div className={styles.header}>
							{title && <h1 className={styles.title}>{title}</h1>}
							{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
						</div>
					)}
					{/* main content */}
					<div className={styles.mainContent}>{children}</div>
				</div>
			</div>
		</div>
	);
  }
);
